<div>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a
              class="header fs-24 fw-7 text-neutral-dark-grey text-decoration-none"
              routerLink="{{listUrls.url}}"
              >{{listUrls.label}}</a
            >
          </li>
      @for (item of listUrls.children; track $index) {
        
          <li
            class="breadcrumb-item header fs-24 fw-7"
            [ngClass]="{'active': listUrls.children.length - 1 == $index,'text-primary' : listUrls.children.length-1 == $index}"
            aria-current="page"
          >
          @if ( listUrls.children.length-1 !== $index) {
            <a
            class="header fs-24 fw-7 text-neutral-dark-grey text-decoration-none"
            routerLink="{{item.url}}"
            >{{item.label}}</a
          >
          }@else {
            {{item.label}}
          }
         
           
          </li>
       }
      
    </ol>
  </nav>
</div>
